import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import { mediaListService } from 'src/services/media-list.service'

export const useRemoveMedia = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (ids: string[]) => {
      return mediaListService.deleteMedia(ids)
    },
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_KEYS.MEDIA_LIST])
      },
    },
  )
}
